import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@progress/kendo-react-common';
import { exclamationCircleIcon, warningTriangleIcon } from '@progress/kendo-svg-icons';
import { DlpIssue, countIssues } from 'utils/dlpConfigurationValidation';

interface IssueBadgesProps {
    issues: DlpIssue[];
    // Compact: counts only (list items). Otherwise "N errors / N warnings".
    compact?: boolean;
}

export function IssueBadges({ issues, compact = false }: IssueBadgesProps) {
    const { t } = useTranslation();
    const { errors, warnings } = countIssues(issues);

    return (
        <>
            {errors > 0 && (
                <span className="issue-pill err">
                    <SvgIcon icon={exclamationCircleIcon} size="xsmall" />
                    {compact ? errors : t('dlpConfiguration.issues.errors', { count: errors })}
                </span>
            )}
            {warnings > 0 && (
                <span className="issue-pill warn">
                    <SvgIcon icon={warningTriangleIcon} size="xsmall" />
                    {compact ? warnings : t('dlpConfiguration.issues.warnings', { count: warnings })}
                </span>
            )}
        </>
    );
}
